<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">ALSO BY ALEX WALTERS</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The DI Alec McKay Series</span></span></b></p>
<p class="subsq also-by-content"><span class="content-external-link">Candles and Roses (Book 1)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Death Parts Us (Book 2)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Their Final Act (Book 3)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Expiry Date (Book 4)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">For Their Sins (Book 5)</span></p>
<p class="subsq also-by-content"><span class="content-external-link">A Parting Gift (Book 6)</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-563">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-gradient-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><span class="content-external-link">Winterman</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-alex-walters.vue?29ea3893